module.exports = __webpack_public_path__ + "img/header.b6fc20c4.png";